import { render, staticRenderFns } from "./accountWB.vue?vue&type=template&id=37da34c1&scoped=true"
import script from "./accountWB.vue?vue&type=script&lang=js"
export * from "./accountWB.vue?vue&type=script&lang=js"
import style0 from "./accountWB.vue?vue&type=style&index=0&id=37da34c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37da34c1",
  null
  
)

export default component.exports